<div class="data-table-wrapper">
  @if (filterable || showPagination) {
  <div class="table-toolbar">
    @if (showPagination) {
    <div class="show-per-page">
      Show
      <select class="select-sm" [ngModel]="pageSize()" (change)="onPageSizeChange($event)"
        (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()" aria-label="Rows per page">
        @for (size of pageSizeOptions; track size) {
        <option [value]="size">{{ size }}</option>
        }
      </select>
      per page
    </div>
    }

    @if (filterable) {
    <div class="filter-wrapper">
      <label>Filter:</label>
      <input type="text" class="input-sm" [placeholder]="filterPlaceholder" [ngModel]="filterText()"
        (input)="onFilterInput($event)" aria-label="Filter table results" />
    </div>
    }
  </div>
  }

  <div class="table-responsive" [style.max-height]="maxHeight">
    <table class="results-table">
      <thead>
        <tr>
          @if (showCheckbox) {
          <th class="checkbox-col" aria-label="Row selection"></th>
          }
          @for (col of columns; track col.key) {
          <th [style.width]="col.width" [style.minWidth]="col.minWidth" [class.align-center]="col.align === 'center'"
            [class.align-right]="col.align === 'right'" [class.sortable]="col.sortable"
            [attr.aria-label]="col.sortable ? ('Sort by ' + col.header) : col.header"
            (click)="col.sortable && onSortClick(col)">
            {{ col.header }}
            @if (col.sortable) {
            <span class="sort-icon" [class.active]="sortField() === col.key">
              {{ sortField() === col.key && !sortAsc() ? '▼' : '▲' }}
            </span>
            }
          </th>
          }
        </tr>
      </thead>
      <tbody>
        @if (pagedData().length === 0) {
        <tr>
          <td [attr.colspan]="totalColspan()" class="empty-state">{{ emptyMessage }}</td>
        </tr>
        } @else {
        @for (item of pagedData(); track trackBy(item)) {
        <tr [class.selected]="isSelected(item)" (click)="onRowClick(item)">
          <!-- Replace the existing checkbox input with keyboard support -->
          @if (showCheckbox) {
          <td class="checkbox-col">
            @if (radioMode) {
            <!-- <input type="radio" class="table-checkbox row-radio" name="data-table-selection"
              [checked]="isSelected(item)" [attr.aria-label]="'Select row ' + ($index + 1)"
              (keydown.enter)="onRowClick(item)" (keydown.space)="$event.preventDefault(); onRowClick(item)"
              (change)="onRowClick(item)" style="pointer-events: auto;" /> -->
              <input
    type="radio"
    class="table-checkbox row-radio"
    name="data-table-selection"
    [checked]="isSelected(item)"
    (keydown.enter)="onRowClick(item)" (keydown.space)="$event.preventDefault(); onRowClick(item)"
    [attr.aria-label]="'Select row ' + ($index + 1)"
    (click)="onRadioClick($event, item)"
  />
            } @else {
            <input type="checkbox" class="table-checkbox row-checkbox" [checked]="isSelected(item)"
              [attr.aria-label]="'Select row ' + ($index + 1)" (keydown.enter)="onRowClick(item)"
              (keydown.space)="$event.preventDefault(); onRowClick(item)" style="pointer-events: auto;" />
            }
          </td>
          }
          @for (col of columns; track col.key) {
          <td [class.bold-text]="col.bold" [class.align-center]="col.align === 'center'"
            [class.align-right]="col.align === 'right'">
            {{ getCellValue(item, col) }}
          </td>
          }
        </tr>

        @if (rowDetailTemplate) {
        <tr class="notes-row" [class.selected]="isSelected(item)">
          <td [attr.colspan]="totalColspan()">
            <ng-container *ngTemplateOutlet="rowDetailTemplate; context: { $implicit: item }">
            </ng-container>
          </td>
        </tr>
        }
        }
        }
      </tbody>
    </table>
  </div>

  @if (showPagination) {
  <footer class="table-footer">
    <div class="showing-count">
      @if (isFiltered()) {
      Showing
      {{ sortedData().length ? filteredRangeStart() + '-' + filteredRangeEnd() : '0' }}
      of {{ sortedData().length }} filtered records
      (out of {{ totalRecordCount() }} total)
      } @else {
      Showing
      {{ sortedData().length ? rangeStart() + '-' + rangeEnd() : '0' }}
      of {{ totalRecordCount() }} {{ totalRecordCount() === 1 ? 'record' : 'records' }}
      }
    </div>

    <div class="pagination-controls">
      <button class="pag-btn" [disabled]="currentPage() === 1" (click)="goToFirstPage()"
        aria-label="Go to first page">&laquo;&laquo;</button>
      <button class="pag-btn" [disabled]="currentPage() === 1" (click)="goToPrevPage()"
        aria-label="Go to previous page">&laquo;</button>
      <button class="pag-btn active" [attr.aria-label]="'Current page, page ' + currentPage()">{{ currentPage()
        }}</button>
      <button class="pag-btn" [disabled]="currentPage() === totalPages()" (click)="goToNextPage()"
        aria-label="Go to next page">&raquo;</button>
      <button class="pag-btn" [disabled]="currentPage() === totalPages()" (click)="goToLastPage()"
        aria-label="Go to last page">&raquo;&raquo;</button>
    </div>
  </footer>
  }
</div>